
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { Moment } from 'moment-timezone';
import { Company, DbTimestamp, isSsoExceptionEmail } from '@run-diffusion/shared';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { setLastSsoProviderVal } from '@/utils';

export default Vue.extend({
	name: 'DeviceAndLoginMethodProtector',
	data () {
		return {
			RUNNITS_OWNER_SELECTION,
			isTakingControl: false,
		};
	},
	computed: {
		...mapState([
			'authUser',
			'runnitState',
			'user',
			'runnitState',
			'isAdminProxyingUser',
			'deviceReportLocal',
			'team',
		]),
		...mapGetters([
			'showStripeUserMembershipPortalBtn',
		]),
		shouldShowEnforceSsoProviderProtection () {
			if (!this.user) return false;
			if (this.runnitState.runnitsOwnerSelection !== RUNNITS_OWNER_SELECTION.TEAM) return false;

			// Check if SSO is configured and enforcement is enabled
			const sso: Company['sso'] = this._get(this.team, 'company.sso');
			if (!(sso?.identifier && sso?.enforceAuthProvider)) return false;

			// Check if user is admin
			if (this.user?.isAdmin || this.isAdminProxyingUser) return false;

			// SSO Exception (break-glass): listed emails are exempt from enforcement and may use any auth method
			if (isSsoExceptionEmail(sso, this.user?.email)) return false;

			// Check if user logged in via SSO
			return !(this._get(this.authUser, 'providerData') || []).every(({ providerId }) => providerId === `saml.${sso.identifier}`);
		},
		shouldShowSimultaneousLoginsProtection () {
			const currentVisitorId: string = this._get(this.deviceReportLocal, 'fingerprint.visitorId') || null;
			const lastVisitorId: string = this._get(this.user, 'loginInfo.lastFingerprint.visitorId') || null;
			const loginLastAtMoment: Moment = this._get(this.deviceReportLocal, 'loginLastAtMoment') || null;
			const userLastAt: DbTimestamp = this._get(this.user, 'loginInfo.lastAt') || null;

			return !!(
				this.user &&
				!this.user.isAdmin &&
				!this.isAdminProxyingUser &&
				currentVisitorId &&
				lastVisitorId &&
				currentVisitorId !== lastVisitorId &&
				loginLastAtMoment &&
				userLastAt &&
				loginLastAtMoment.isSameOrBefore(userLastAt.toMillis())
			);
		},
	},
	methods: {
		...mapActions([
			'updateToolbar',
			'incrementOpenRunnitAccountSelectionMenuTrigger',
			'setUpsellDialog',
		]),
		async onTakeControl () {
			this.isTakingControl = true;
			await new Promise(resolve => setTimeout(resolve, 5000));
			window.location.reload();
		},
		onLogout () {
			this.$emit('on-logout');
		},
		onSsoEnforcementClick () {
			const ssoIdentifier: string = this._get(this.team, 'company.sso.identifier');
			if (ssoIdentifier) {
				setLastSsoProviderVal(ssoIdentifier);
				this.updateToolbar({
					changeLoginSettingsDialogConfig: {
						open: true,
						requireSwitchToSso: true,
					},
				});
			}
		},
	},
});
